// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","453":"d855a71b","455":"c461acb5","952":"c730f37f","977":"2caed02d"}[chunkId] + ".chunk.js";
};